import * as firebase from 'firebase'

const getUid = () => firebase.auth().currentUser.uid

const createFirebaseItem = (location, data) => {
  const uid = getUid()

  return firebase.database().ref(location).push(data)
    .then(ref => {
      const childRef = firebase.database().ref(`accounts/${uid}/${location}/${ref.key}`)
      return childRef.set(true)
        .then(() => {
          return ref.key
        })
    })
}

const listenForFirebaseItems = (location, callback) => {
  const uid = getUid()
  const itemState = {}

  const itemsRef = firebase.database().ref(`accounts/${uid}/${location}`)
  itemsRef.on('child_added', addedSnapshot => {
    firebase.database().ref(`${location}/${addedSnapshot.key}`)
      .on('value', snapshot => {
        const item = snapshot.val()
        if (item) {
          item.remove = () => {
            addedSnapshot.ref.remove()
              .then(snapshot.ref.remove())
        }
        item.id = snapshot.key
        itemState[snapshot.key] = item
        callback(itemState)
        }
      })
  })
  itemsRef.on('child_removed', removedSnapshot => {
    delete itemState[removedSnapshot.key]
    callback(itemState)
  })
}

export {
  createFirebaseItem,
  listenForFirebaseItems
}



// WEBPACK FOOTER //
// ./src/firebase-helpers.js